import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { SignupBasicComponent } from './components/signup-basic/signup-basic.component';
import { SignupPersonalComponent } from './components/signup-personal/signup-personal.component';
import { SignupProfessionalComponent } from './components/signup-professional/signup-professional.component';
import { SignupReligionComponent } from './components/signup-religion/signup-religion.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileListComponent } from './components/profile-list/profile-list.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { PartnerPreferencesComponent } from './components/partner-preferences/partner-preferences.component';
import { ChatComponent } from './components/chat/chat.component';
import { PlansComponent } from './components/plans/plans.component';
import { authGuard } from './core/guard/auth/auth.guard';
import { DivorcedComponent } from './components/divorced/divorced.component';
import { WidowedComponent } from './components/widowed/widowed.component';
import { FavoritesComponent } from './components/favorites/favorites.component';
import { InterestsComponent } from './components/interests/interests.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { MyHoroscopeComponent } from './components/my-horoscope/my-horoscope.component';
import { WeddingLayoutComponent } from './wedding-services/wedding-layout/wedding-layout.component';
import { ServiceCategoryComponent } from './wedding-services/service-category/service-category.component';
import { ServiceListComponent } from './wedding-services/service-list/service-list.component';
import { BookingCalendarComponent } from './wedding-services/booking-calendar/booking-calendar.component';
import { BookingFormComponent } from './wedding-services/booking-form/booking-form.component';
import { MerchantBookingComponent } from './merchant/merchant-booking/merchant-booking.component';
import { MerchantDetailsComponent } from './wedding-services/merchant-details/merchant-details.component';
import { ServiceDetailsComponent } from './wedding-services/service-details/service-details.component';
import { BookingDetailsComponent } from './wedding-services/booking-details/booking-details.component';
import { PaymentDetailsComponent } from './wedding-services/payment-details/payment-details.component';
import { PaymentCheckoutComponent } from './wedding-services/payment-checkout/payment-checkout.component';
import { ServiceEnquiryComponent } from './wedding-services/service-enquiry/service-enquiry.component';
import { ServiceEnquiryListComponent } from './wedding-services/service-enquiry-list/service-enquiry-list.component';
import { ShortlistedMerchantsComponent } from './wedding-services/shortlisted-merchants/shortlisted-merchants.component';
import { MerchantRegisterComponent } from './merchant/merchant-register/merchant-register.component';
import { MerchantLoginComponent } from './merchant/merchant-login/merchant-login.component';
import { MerchantDashboardComponent } from './merchant/merchant-dashboard/merchant-dashboard.component';
import { merchantGuard } from './core/guard/merchant/merchant.guard';
import { MerchantAboutUsComponent } from './merchant/merchant-about-us/merchant-about-us.component';
import { MerchantProfileComponent } from './merchant/merchant-profile/merchant-profile.component';
import { MerchantServicesComponent } from './merchant/merchant-services/merchant-services.component';
import { MerchantServiceEditComponent } from './merchant/merchant-service-edit/merchant-service-edit.component';
import { MerchantLayoutComponent } from './merchant/merchant-layout/merchant-layout.component';
import { MerchantCalendarComponent } from './merchant/merchant-calendar/merchant-calendar.component';
import { MerchantPortfolioComponent } from './merchant/merchant-portfolio/merchant-portfolio.component';
import { MerchantMessagesComponent } from './merchant/merchant-messages/merchant-messages.component';
import { MerchantPaymentPreferenceComponent } from './merchant/merchant-payment-preference/merchant-payment-preference.component';
import { MerchantPaymentComponent } from './merchant/merchant-payment/merchant-payment.component';
import { MerchantRevenueComponent } from './merchant/merchant-revenue/merchant-revenue.component';
import { MerchantEnquiryComponent } from './merchant/merchant-enquiry/merchant-enquiry.component';
import { MerchantSubscriptionComponent } from './merchant/merchant-subscription/merchant-subscription.component';
import { MerchantAdvertisementComponent } from './merchant/merchant-advertisement/merchant-advertisement.component';
import { AdminLoginComponent } from './components/admin/admin-login/admin-login.component';
import { AdminShellComponent } from './components/admin/admin-shell/admin-shell.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { PlanManagerComponent } from './components/admin/plan-manager/plan-manager.component';
import { UserManagerComponent } from './components/admin/user-manager/user-manager.component';
import { MerchantManagerComponent } from './components/admin/merchant-manager/merchant-manager.component';
import { BrokerManagerComponent } from './components/admin/broker-manager/broker-manager.component';
import { VerificationManagerComponent } from './components/admin/verification-manager/verification-manager.component';
import { ReportManagerComponent } from './components/admin/report-manager/report-manager.component';
import { SupportManagerComponent } from './components/admin/support-manager/support-manager.component';
import { BrokerLoginComponent } from './components/broker/broker-login/broker-login.component';
import { BrokerDashboardComponent } from './components/broker/broker-dashboard/broker-dashboard.component';
import { ClaimProfileComponent } from './components/claim-profile/claim-profile.component';
import { SupportComponent } from './components/support/support.component';
import { MyTicketsComponent } from './components/my-tickets/my-tickets.component';
import { AdminGuard } from './core/guard/admin/admin.guard';
import { BrokerGuard } from './core/guard/broker/broker.guard';
import { RmGuard } from './core/guard/rm/rm.guard';
import { RmLoginComponent } from './components/rm/rm-login/rm-login.component';
import { RmDashboardComponent } from './components/rm/rm-dashboard/rm-dashboard.component';
import { RmClientWorkspaceComponent } from './components/rm/rm-client-workspace/rm-client-workspace.component';
import { RmSearchComponent } from './components/rm/rm-search/rm-search.component';
import { AdminRmManagementComponent } from './components/admin/admin-rm-management/admin-rm-management.component';
import { ExpressConciergeRoomComponent } from './components/matches/express-concierge-room/express-concierge-room.component';
import { PostRequirementComponent } from './wedding-services/post-requirement/post-requirement.component';
import { MerchantLeadsComponent } from './merchant/merchant-leads/merchant-leads.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'wedding-services',
    component: ServiceCategoryComponent
  },
  {
    path: 'wedding-services/booking-form',
    component: BookingFormComponent
  },
  {
    path: 'wedding-services/booking-details',
    component: BookingDetailsComponent
  },

  {
    path: 'wedding-services/payment-details',
    component: PaymentDetailsComponent
  },
  {
    path: 'payment-checkout',
    component: PaymentCheckoutComponent
  },
  {
    path: 'wedding-services/service-enquiry/:id',
    component: ServiceEnquiryComponent
  },
  {
    path: 'wedding-services/enquiries',
    component: ServiceEnquiryListComponent
  },
   {
  path: 'wedding-services/shortlisted-merchants',
  component: ShortlistedMerchantsComponent
},
  {
    path: 'wedding-services/:category',
    component: ServiceListComponent
  },
  // {
  //   path: 'wedding-services',
  //   component: ServiceCategoryComponent
  // },

  {
    path: 'wedding-services/booking-calendar/:serviceId',
    component: BookingCalendarComponent
  },

  {
    path: 'wedding-services/booking-form',
    component: BookingFormComponent
  },

  {
    path: 'wedding-services/merchant/:id',
    component: MerchantDetailsComponent
  },

  {
    path: 'wedding-services/service-details/:id',
    component: ServiceDetailsComponent
  },

  // {
  //   path: 'wedding-services/:category',
  //   component: ServiceListComponent
  // },
  {
    path: 'wedding-services/lead/post-requirement',
    component: PostRequirementComponent
  },
 
  // {
  //  path:'wedding-services/booking-details',
  //  component:BookingDetailsComponent
  // },

  // {
  //  path:'wedding-services/payment-details',
  //  component:PaymentDetailsComponent
  // },


  { path: 'merchant/register', component: MerchantRegisterComponent },
  { path: 'merchant/login', component: MerchantLoginComponent },
  {
    path: 'merchant',
    component: MerchantLayoutComponent,
    canActivate: [merchantGuard],

    children: [

      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },

      {
        path: 'dashboard',
        component: MerchantDashboardComponent
      },
      {
        path: 'about-us',
        component: MerchantAboutUsComponent
      },

      {
        path: 'profile',
        component: MerchantProfileComponent
      },

      {
        path: 'services',
        component: MerchantServicesComponent
      },
      {
        path: 'portfolio',
        component: MerchantPortfolioComponent
      },
      {
        path: 'messages',
        component: MerchantMessagesComponent
      },

      {
        path: 'service/edit/:id',
        component: MerchantServiceEditComponent
      },
      {
        path: 'leads',
        component: MerchantLeadsComponent
      },
      {
        path: 'calendar',
        component: MerchantCalendarComponent,
        canActivate: [merchantGuard]
      },
      {
        path: 'bookings',
        component: MerchantBookingComponent
      },
      {
        path: 'payments',
        component: MerchantPaymentComponent
      },
      {
        path: 'revenue',
        component: MerchantRevenueComponent
      },
      {
        path: 'payment-preference/:bookingId',
        component: MerchantPaymentPreferenceComponent
      },
      {
        path: 'enquiries',
        component: MerchantEnquiryComponent
      },
      {
        path: 'subscription',
        component: MerchantSubscriptionComponent
      },
      {
        path: 'advertisement',
        component: MerchantAdvertisementComponent
      }

    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'signup-basic', component: SignupBasicComponent },
  { path: 'signup-personal', component: SignupPersonalComponent },
  { path: 'signup-professional', component: SignupProfessionalComponent },
  { path: 'signup-religion', component: SignupReligionComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  { path: 'express-concierge', component: ExpressConciergeRoomComponent, canActivate: [authGuard] },
  { path: 'my-profile', component: MyProfileComponent, canActivate: [authGuard] },
  { path: 'my-horoscope', component: MyHoroscopeComponent, canActivate: [authGuard] },
  { path: 'profiles', component: ProfileListComponent },
  { path: 'search', redirectTo: 'profiles', pathMatch: 'full' },
  { path: 'profile-details/:id', component: ProfileDetailsComponent },
  { path: 'partner-preferences', component: PartnerPreferencesComponent, canActivate: [authGuard] },
  { path: 'chat', component: ChatComponent, canActivate: [authGuard] },
  { path: 'plans', component: PlansComponent, canActivate: [authGuard] },
  { path: 'favorites', component: FavoritesComponent, canActivate: [authGuard] },
  { path: 'interests', component: InterestsComponent, canActivate: [authGuard] },
  { path: 'divorced', component: DivorcedComponent, canActivate: [authGuard] },
  { path: 'discover/divorced', component: DivorcedComponent, canActivate: [authGuard] },
  { path: 'widowed', component: WidowedComponent, canActivate: [authGuard] },
  { path: 'discover/widowed', component: WidowedComponent, canActivate: [authGuard] },
  { path: 'support', component: SupportComponent },
  { path: 'my-tickets', component: MyTicketsComponent, canActivate: [authGuard] },
  // ── Admin Panel ────────────────────────────────────────────────────────
  { path: 'admin/login', component: AdminLoginComponent },
  {
    path: 'admin', component: AdminShellComponent, canActivate: [AdminGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: AdminDashboardComponent },
      { path: 'plans', component: PlanManagerComponent },
      { path: 'users', component: UserManagerComponent },
      {
  path: 'merchants',
  component: MerchantManagerComponent
},
      { path: 'brokers', component: BrokerManagerComponent },
      { path: 'relationship-managers', component: AdminRmManagementComponent },
      { path: 'verifications', component: VerificationManagerComponent },
      { path: 'reports', component: ReportManagerComponent },
      { path: 'support', component: SupportManagerComponent },
    ]
  },
  // ── Relationship Manager (RM) Concierge Portal ─────────────────────────
  { path: 'rm/login', component: RmLoginComponent },
  { path: 'rm/dashboard', component: RmDashboardComponent, canActivate: [RmGuard] },
  { path: 'rm/client/:id', component: RmClientWorkspaceComponent, canActivate: [RmGuard] },
  { path: 'rm/search', component: RmSearchComponent, canActivate: [RmGuard] },
  { path: 'rm', redirectTo: 'rm/dashboard', pathMatch: 'full' },
  // ── Broker Portal & Claim ──────────────────────────────────────────────
  { path: 'broker/login', component: BrokerLoginComponent },
  { path: 'broker/dashboard', component: BrokerDashboardComponent, canActivate: [BrokerGuard] },
  { path: 'broker', redirectTo: 'broker/dashboard', pathMatch: 'full' },
  { path: 'claim', component: ClaimProfileComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
